<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'PATIENT-IMPORT'" [breadcrumb]="''" [count]="count"
    icon="fa-users">
</app-breadcrumb>
<!-- body -->
<div class="content-background p-0">
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab title="{{ 'PATIENT-IMPORT-BATCHES' | translate }}" [selected]="true">
            <ng-template kendoTabContent>
                <div class="row mt-2">
                    <div class="col-sm-12">
                        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                            <app-advanced-mode id="patientImportGridAdvancedSwitch"
                                [storageKey]="'patients-import-list'" (collapsibleToggle)="enableAdvanced=$event">
                            </app-advanced-mode>
                            <input #search kendoTextBox class="ml-4 button-search"
                                placeholder="{{ 'SEARCH-NAME' | translate }}" (keyup)="searchFieldChange(search.value)"
                                title="{{ 'SEARCH-NAME' | translate }}" />
                            <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
                        </div>
                    </div>
                </div>
                <div class="mt-3 ml-3 mr-3">
                    <kendo-grid #grid [data]="gridView" [navigable]="true"
                        [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                        [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort"
                        [filter]="state.filter" [sortable]="true" [filterable]="enableAdvanced"
                        [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
                        [kendoGridSelectBy]="'id'" [selectedKeys]="selectedRecord"
                        (selectedKeysChange)="onSelectedKeysChange($event)" (dataStateChange)="dataStateChange($event);"
                        (dblclick)="dblClickImportBatchEvent($event)" [selectable]="{ mode: 'single' }">
                        <kendo-grid-messages noRecords="{{ 'NO-PATIENT-IMPORT-BATCHES' | translate }}">
                        </kendo-grid-messages>
                        <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
                            <button kendoButton (click)="refresh()" class="float-right">
                                {{'GRID-REFRESH' | translate }}<i class="far fa-sync-alt mt-1"></i>
                            </button>
                        </ng-template>
                        <kendo-grid-column class="ellipsis-text" field="name" title="{{ 'NAME' | translate }}"
                            [width]="15">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.name}}">{{dataItem.name}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column class="ellipsis-text" field="description"
                            title="{{ 'DESCRIPTION' | translate }}" [width]="20" [hidden]="true">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.description}}">{{dataItem.description}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column class="ellipsis-text" field="documentName"
                            title="{{ 'FILENAME' | translate }}" [width]="15">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.documentName}}">{{dataItem.documentName}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column class="ellipsis-text" field="channelName"
                            title="{{ 'CHANNEL-ENROLLMENT' | translate }}" [width]="15">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.channelName}}">{{dataItem.channelName}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column class="text-center" *ngIf="communityEnabled" field="sendInvite" [width]="10"
                            title="{{ 'SEND-INVITE' | translate }}" filter="boolean">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <i *ngIf="dataItem.sendInvite" class="fas fa-check"></i>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="lastModifiedBy" [width]="10"
                            title="{{ 'LAST-MODIFIED-BY' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="lastModifiedOn" [width]="12"
                            title="{{ 'LAST-MODIFIED-DATE' | translate }}" filter="date" format="{0:g}">
                        </kendo-grid-column>
                        <kendo-grid-column field="parsingErrors" class="text-center"
                            title="{{ 'IMPORT-PARSING' | translate }}" filter="boolean" [width]="8">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div style="padding-bottom: 21px;">
                                    <i *ngIf="!dataItem.parsingErrors" class="fas fa-check-circle valid-status"
                                        title="{{ 'IMPORT-PARSING-PASSED' | translate }}">
                                    </i>
                                    <i *ngIf="dataItem.parsingErrors" class="fas fa-times-circle invalid-status"
                                        title="{{ 'IMPORT-PARSING-ERRORS' | translate }} {{dataItem.parsingErrorMessage}}">
                                    </i>
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="validationErrors" class="text-center"
                            title="{{ 'IMPORT-VALIDATION' | translate }}" filter="boolean" [width]="8">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <i *ngIf="!dataItem.validationErrors" class="fas fa-check-circle valid-status"
                                    title="{{ 'IMPORT-VALIDATION-ERRORS' | translate }}">
                                </i>
                                <i *ngIf="dataItem.validationErrors" class="fas fa-times-circle invalid-status"
                                    title="{{ 'IMPORT-VALIDATION-ERRORS' | translate }}">
                                </i>
                                <!--Show Counts-->
                                <div>
                                    {{dataItem.itemsValidCount}}&nbsp;{{ 'OF' | translate
                                    }}&nbsp;{{dataItem.itemsTotalCount}}
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="importStage" title="{{ 'IMPORT-STAGE' | translate }}" [width]="15"
                            [columnMenu]="false">
                            <ng-template kendoGridFilterCellTemplate let-filter>
                                <app-dropdown-filter [filter]="filter" [data]="importStages" filterField="importStage"
                                    selectDefaultText="{{ 'SELECT-IMPORT-STAGE' | translate }}" textField="label"
                                    valueField="value">
                                </app-dropdown-filter>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.stageName }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column [width]="15" title="{{ 'ACTIONS' | translate }}" class="text-center">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}"
                                    (click)="editHandler(dataItem['id'])">
                                </i>
                                &nbsp;
                                <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                                    (click)="deleteHandler(dataItem['id'])">
                                </i>
                                &nbsp;
                                <i class="fas fa-file-import fa-lg pointer" style="color: #bc7410;"
                                    title="{{ 'PROCESS-BATCH' | translate }}" (click)="importHandler(dataItem['id'])">
                                </i>
                                &nbsp;
                                <i class="fas fa-file-download fa-lg pointer" style="color: #bc7410;"
                                    title="{{ 'DOWNLOAD-PROCESS-BATCH-ITEMS' | translate }}"
                                    (click)="downloadHandler(dataItem['id'])">
                                </i>
                            </ng-template>
                        </kendo-grid-command-column>
                    </kendo-grid>
                    <div class="float-right mt-3 mb-3">
                        <button kendoButton [primary]="false" type="button" (click)="addHandler()">
                            {{'ADD' | translate}}<i class="far fa-plus"></i>
                        </button>
                    </div>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="{{ 'MEMBERS' | translate:patientLabel }}" [disabled]="!showPatientsTab">
            <ng-template kendoTabContent>
                <app-patient-import-item-list [patientImportBatch]="selectedPatientImport">
                </app-patient-import-item-list>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
</div>

<!--Delete confirmation dialog-->
<kendo-dialog *ngIf="deleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="deleteDialogOpened = false">
    <p>{{'CONFIRM-PATIENT-IMPORT-DELETION' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedPatientImport.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Export confirmation dialog-->
<kendo-dialog *ngIf="exportDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400" [minWidth]="400"
    (close)="exportDialogOpened = false">
    <span>{{'DOWNLOAD-PROCESS-BATCH-CONFIRMATION' | translate}}</span><br /><span
        class="k-font-weight-bold">{{selectedPatientImport.name}}</span>
    <form novalidate [formGroup]="exportForm" class="k-form">
        <div class="mt-3">
            <input type="radio" value="invalid" name="exportType" formControlName="exportType" id="radioExportInvalid"
                kendoRadioButton />
            <label class="k-radio-label" for="radioExportInvalid">{{'DOWNLOAD-PROCESS-BATCH-EXPORT-INVALID' |
                translate}}
            </label>
            <br />
            <input type="radio" value="all" name="exportType" formControlName="exportType" id="radioExportAll"
                kendoRadioButton />
            <label class="k-radio-label" for="radioExportAll">{{'DOWNLOAD-PROCESS-BATCH-EXPORT-ALL' |
                translate}}
            </label>
        </div>
    </form>
    <kendo-dialog-actions>
        <button kendoButton (click)="exportAction(false)">{{'CANCEL' | translate}}</button>
        <button [disabled]="!exportForm.valid || !exportForm.dirty" appPreventClick kendoButton
            (click)="exportAction(true)">{{'EXPORT' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Import confirmation dialog-->
<kendo-dialog *ngIf="importDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="importDialogOpened = false">
    <p>{{'CONFIRM-BATCH-PROCESS' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedPatientImport.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="importAction(false)">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="importAction(true)">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Add/Edit form-->
<app-patient-import-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-patient-import-edit>